import { useMediaQuery } from '@mantine/hooks'

export const use1080pOrLess = (): boolean => {
  return useMediaQuery(`(max-width: 120.1em)`)
}
